import pre_designed_template4 from "../../../assests/Images/TemplateElement/pre_designed_template4.png";
import { DATE } from "../../../shared/constants.js";
import CardTemplate from "./CardTemplate";

function PreDefineTemplate4({ heading, date, journalId,pageRefresh,ref ,menuShow}) {
  return (
    <CardTemplate
      journalId={journalId}
      headingText={heading}
      date={date || DATE.JOURNAL_FORMAT}
      bgColor="#0ae2cd"
      headingColor="#000000"
      textColor="#000000"
      imageTopLeft={pre_designed_template4}
      imageTopLeftStyle={{ width: 70, height: 70, top: 10, left: 10, transform: "rotate(150deg)" }}
      headingMargin={{ xs: "40%", sm: "45%", md: "45%" }}
      pageRefreshCallback={pageRefresh}
      ref={ref}
      menuShow={menuShow}
    />
  );
}

export default PreDefineTemplate4;
